import { enqueue } from "./client";

// Thin, typed wrappers over enqueue() — one per client-emittable event. They
// keep the field placement correct (top-level course_id/lesson_id vs everything
// else inside `properties`) so callers can't get the envelope wrong.

export const trackPageView = (props: {
  page_type: "home" | "course" | "category" | "checkout" | string;
  title_page?: string;
  referrer_page?: string;
  mini_app_uuid?: string;
}) => {
  const { mini_app_uuid, ...rest } = props;
  enqueue("page_view", rest, { mini_app_uuid });
};

export const trackSearchPerformed = (props: {
  query: string;
  results_count?: number;
  clicked_course_id?: number;
  clicked_position?: number;
}) => {
  enqueue("search_performed", props);
};

export const trackCategoryView = (props: {
  category_id: number;
  category_name?: string;
}) => {
  enqueue("category_view", props);
};

export const trackCourseView = (props: {
  course_id: number;
  mini_app_uuid?: string;
  title_course?: string;
  instructor_id?: number;
  category?: string;
  subcategory?: string;
  price_course?: number;
  price_discount?: number;
  has_discount?: boolean;
  avg_rating?: number;
  count_rating?: number;
}) => {
  const { course_id, mini_app_uuid, ...rest } = props;
  enqueue("course_view", rest, { course_id, mini_app_uuid });
};

export const trackCoursePreviewPlayed = (props: {
  course_id: number;
  mini_app_uuid?: string;
  preview_video_id?: string;
  watch_duration_seconds?: number;
  video_duration_seconds?: number;
  watch_percentage?: number;
}) => {
  const { course_id, mini_app_uuid, ...rest } = props;
  enqueue("course_preview_played", rest, { course_id, mini_app_uuid });
};

export const trackCheckoutStarted = (props: {
  course_id: number;
  mini_app_uuid?: string;
  amount_gross?: number;
  amount_discount?: number;
  amount_net?: number;
  coupon_code?: string;
  payment_method?: string;
}) => {
  const { course_id, mini_app_uuid, ...rest } = props;
  enqueue("checkout_started", rest, { course_id, mini_app_uuid });
};

export const trackCourseStarted = (props: {
  course_id: number;
  mini_app_uuid?: string;
  instructor_id?: number;
  days_after_purchase?: number;
}) => {
  const { course_id, mini_app_uuid, ...rest } = props;
  enqueue("course_started", rest, { course_id, mini_app_uuid });
};

export const trackLessonStarted = (props: {
  course_id: number;
  lesson_id: number;
  mini_app_uuid?: string;
  lesson_title?: string;
  lesson_order?: number;
}) => {
  const { course_id, lesson_id, mini_app_uuid, ...rest } = props;
  enqueue("lesson_started", rest, { course_id, lesson_id, mini_app_uuid });
};

export const trackVideoProgress = (props: {
  course_id: number;
  lesson_id: number;
  mini_app_uuid?: string;
  video_id?: string;
  /** 25 | 50 | 75 | 100 — bucketed only, never a per-second stream. */
  progress_percent: 25 | 50 | 75 | 100;
  watch_time_seconds?: number;
  video_duration_seconds?: number;
}) => {
  const { course_id, lesson_id, mini_app_uuid, ...rest } = props;
  enqueue("video_progress", rest, { course_id, lesson_id, mini_app_uuid });
};

export const trackLessonCompleted = (props: {
  course_id: number;
  lesson_id: number;
  mini_app_uuid?: string;
  watch_percentage?: number;
  completed_at?: string;
}) => {
  const { course_id, lesson_id, mini_app_uuid, ...rest } = props;
  enqueue("lesson_completed", rest, { course_id, lesson_id, mini_app_uuid });
};

export const trackCourseCompleted = (props: {
  course_id: number;
  mini_app_uuid?: string;
  completion_percentage?: number;
  days_to_complete?: number;
}) => {
  const { course_id, mini_app_uuid, ...rest } = props;
  enqueue("course_completed", rest, { course_id, mini_app_uuid });
};
